module.exports = __webpack_public_path__ + "img/gear-orange-branch.95e95a41.svg";